'use strict';

var _rollupPluginBabelHelpers = require('./_rollupPluginBabelHelpers-b2d9610a.js');
var React = require('react');
var index = require('./index-fccd5f88.js');
var Typography = require('./Typography-8468e4cf.js');
var Button = require('./Button-ef2d53dd.js');
var Icons = require('./Icons-46f5553f.js');
var injectGlobalCss = require('./injectGlobalCss-bc8cf911.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var css = ".Accordion_module_visuallyHidden__cc42f7aa {\n  position: absolute !important;\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important;\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n}\n\n.Accordion_module_youtubeVideo__cc42f7aa {\n  width: 100%;\n  height: auto;\n  aspect-ratio: 16/9;\n  display: block;\n}\n\n.Accordion_module_Accordion__cc42f7aa {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  padding: 0;\n  border-radius: 14px;\n}\n.Accordion_module_Accordion__cc42f7aa:hover .Accordion_module_Header3__cc42f7aa {\n  text-decoration: underline;\n}\n.Accordion_module_Accordion__cc42f7aa button.Accordion_module_AccordionButton__cc42f7aa {\n  background-color: transparent;\n}\n.Accordion_module_Accordion__cc42f7aa.Accordion_module_Open__cc42f7aa button.Accordion_module_AccordionButton__cc42f7aa svg {\n  transform: rotate(180deg);\n}\n.Accordion_module_Accordion__cc42f7aa .Accordion_module_AccordionContent__cc42f7aa {\n  display: grid;\n  grid-template-rows: 0fr;\n  overflow: hidden;\n  transition: all 0.5s;\n  padding: 0 24px;\n}\n.Accordion_module_Accordion__cc42f7aa .Accordion_module_AccordionContent__cc42f7aa a, .Accordion_module_Accordion__cc42f7aa .Accordion_module_AccordionContent__cc42f7aa button {\n  visibility: hidden;\n}\n.Accordion_module_Accordion__cc42f7aa .Accordion_module_AccordionContent__cc42f7aa .Accordion_module_AccordionInnerContent__cc42f7aa {\n  overflow-y: hidden;\n}\n.Accordion_module_Accordion__cc42f7aa .Accordion_module_AccordionContent__cc42f7aa.Accordion_module_isOpen__cc42f7aa {\n  grid-template-rows: 1fr;\n}\n.Accordion_module_Accordion__cc42f7aa .Accordion_module_AccordionContent__cc42f7aa.Accordion_module_isOpen__cc42f7aa * {\n  visibility: visible;\n}\n\n.Accordion_module_AccordionTop__cc42f7aa {\n  display: flex;\n  justify-content: space-between;\n  row-gap: 14px;\n  cursor: pointer;\n  padding: 14px 24px;\n  padding-right: 14px;\n}\n.Accordion_module_AccordionTop__cc42f7aa .Accordion_module_Header3__cc42f7aa {\n  padding: 0;\n  display: flex;\n  align-items: center;\n  gap: 14px;\n}\n.Accordion_module_AccordionTop__cc42f7aa .Accordion_module_Header3__cc42f7aa span {\n  line-height: 1.2;\n}\n.Accordion_module_AccordionTop__cc42f7aa svg {\n  flex-shrink: 0;\n}\n.Accordion_module_AccordionTop__cc42f7aa button {\n  padding: 0;\n  width: 48px;\n  transition: all 0.5s;\n}\n.Accordion_module_AccordionTop__cc42f7aa button :hover,\n.Accordion_module_AccordionTop__cc42f7aa button :focus {\n  background-color: transparent;\n}\n.Accordion_module_AccordionTop__cc42f7aa button span {\n  padding-left: 0;\n  padding-right: 0;\n  background-color: transparent;\n  width: 48px;\n}";
injectGlobalCss.injectCss(css, "/opt/atlassian/pipelines/agent/build/src/stories/components/Molecules/Accordion/Accordion.module.scss");
var modules_0a5b548b = {"uiBreakMax":"strip-units(1920px)","uiBreakDesktop":"strip-units(1366px)","uiBreakMobilePortraitMin":"strip-units(300px)","uiBreakTabletPortraitMin":"strip-units(700px)","uiBreakDesktopMin":"strip-units(1080px)","uiBreakWideScreenMin":"strip-units(1920px)","visuallyHidden":"Accordion_module_visuallyHidden__cc42f7aa","youtubeVideo":"Accordion_module_youtubeVideo__cc42f7aa","Accordion":"Accordion_module_Accordion__cc42f7aa","Header3":"Accordion_module_Header3__cc42f7aa","AccordionButton":"Accordion_module_AccordionButton__cc42f7aa","Open":"Accordion_module_Open__cc42f7aa","AccordionContent":"Accordion_module_AccordionContent__cc42f7aa","AccordionInnerContent":"Accordion_module_AccordionInnerContent__cc42f7aa","isOpen":"Accordion_module_isOpen__cc42f7aa","AccordionTop":"Accordion_module_AccordionTop__cc42f7aa"};

var Accordion = function Accordion(_ref) {
  var accordionBackgroundColor = _ref.accordionBackgroundColor,
    extraClass = _ref.extraClass,
    title = _ref.title,
    titleColor = _ref.titleColor,
    children = _ref.children,
    faq = _ref.faq,
    accordionId = _ref.accordionId,
    openByDefault = _ref.openByDefault,
    _ref$titleFontSize = _ref.titleFontSize,
    titleFontSize = _ref$titleFontSize === void 0 ? "BASE" : _ref$titleFontSize,
    titleSerif = _ref.titleSerif,
    iconName = _ref.iconName,
    iconColor = _ref.iconColor,
    accordionOnClick = _ref.accordionOnClick;
  var _useState = React.useState(openByDefault),
    _useState2 = _rollupPluginBabelHelpers._slicedToArray(_useState, 2),
    isActive = _useState2[0],
    setIsActive = _useState2[1];
  var accordionSetId = accordionId ? accordionId.replace(/[^a-zA-Z0-9]+/g, "") : title.replace(/[^a-zA-Z0-9]+/g, "");
  return /*#__PURE__*/React__default["default"].createElement("div", _rollupPluginBabelHelpers._extends({
    className: [modules_0a5b548b.Accordion, isActive ? modules_0a5b548b.Open : modules_0a5b548b.Closed, extraClass].join(" "),
    style: {
      backgroundColor: accordionBackgroundColor ? accordionBackgroundColor : null
    }
  }, faq ? {
    itemScope: " ",
    itemProp: "mainEntity",
    itemType: "https://schema.org/Question"
  } : {}), /*#__PURE__*/React__default["default"].createElement("div", {
    id: "accordionContainer" + accordionSetId + "",
    className: modules_0a5b548b.AccordionTop,
    onClick: function onClick(e) {
      setIsActive(!isActive);
      accordionOnClick ? accordionOnClick(e, isActive) : null;
    }
  }, /*#__PURE__*/React__default["default"].createElement(Typography.Header3, _rollupPluginBabelHelpers._extends({
    extraClass: modules_0a5b548b.Header3,
    id: "accordionTitle" + accordionSetId + "",
    fontSize: titleFontSize,
    bold: true,
    serif: titleSerif ? true : false
  }, faq ? {
    itemProp: "name"
  } : {}), iconName ? /*#__PURE__*/React__default["default"].createElement(Icons.Icon, {
    iconName: iconName,
    iconColor: iconColor,
    iconWSize: 24,
    iconHSize: 24
  }) : null, /*#__PURE__*/React__default["default"].createElement(Typography.Span, {
    color: titleColor,
    bold: true,
    serif: titleSerif ? true : false,
    fontSize: titleFontSize
  }, title)), /*#__PURE__*/React__default["default"].createElement(Button.Button, {
    icon: "ICON",
    iconName: "ui-arrow-short--down",
    iconActive: "ui-arrow-short--up",
    iconColor: iconColor || "#444f6b",
    iconWSize: 42,
    iconHSize: 42,
    ariaLabel: title,
    label: title,
    ariaExpanded: isActive ? "true" : "false",
    ariaControls: "accordionControlsID" + accordionSetId + "",
    style: "PLAIN",
    extraClass: modules_0a5b548b.AccordionButton
  })), /*#__PURE__*/React__default["default"].createElement("div", _rollupPluginBabelHelpers._extends({
    className: [modules_0a5b548b.AccordionContent, isActive ? modules_0a5b548b.isOpen : null].join(" "),
    id: "accordionControlsID" + accordionSetId + ""
  }, faq ? {
    itemScope: " ",
    itemProp: "acceptedAnswer",
    itemType: "https://schema.org/Answer"
  } : {}, {
    "aria-hidden": isActive ? "false" : "true",
    "aria-labelledby": "accordionTitle" + accordionSetId + "",
    role: "region"
  }), /*#__PURE__*/React__default["default"].createElement("div", _rollupPluginBabelHelpers._extends({
    className: modules_0a5b548b.AccordionInnerContent
  }, faq ? {
    itemProp: "text"
  } : {}), children)));
};
var accordionPropTypes = {
  accordionBackgroundColor: index.propTypes.exports.string,
  extraClass: index.propTypes.exports.string,
  faq: index.propTypes.exports.bool,
  title: index.propTypes.exports.node,
  titleColor: index.propTypes.exports.string,
  accordionId: index.propTypes.exports.string,
  openByDefault: index.propTypes.exports.bool,
  titleFontSize: index.propTypes.exports.oneOf(["XXL", "XL", "L", "M", "BASE", "S", "XS", "XXS"]),
  iconName: index.propTypes.exports.string,
  iconColor: index.propTypes.exports.string,
  accordionOnClick: index.propTypes.exports.func
};
Accordion.propTypes = accordionPropTypes;

exports.Accordion = Accordion;
